module.exports = "<a target=\"_blank\" (click)=\"updateTimestamp()\" [href]=\"currencyConverterUrl\"><span class=\"hEight currency-code\" [innerText]='currencyCode'></span></a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/currency-converter/currency-converter.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/currency-converter/currency-converter.component.html
// module chunks = 0